import { forwardRef, useContext } from 'react'
import { RadioContext } from './radio-context'
import { StyledRadioIndicator } from '../styled-components'

const RadioIndicator = forwardRef((props, forwardedRef) => {
  const { ...indicatorProps } = props
  const context = useContext(RadioContext)

  if (!context.checked) {
    return null
  }

  return (
    <StyledRadioIndicator
      size={context?.size}
      variant={context?.variant}
      data-state={context.getState(context.checked)}
      data-disabled={context.disabled ? '' : undefined}
      {...indicatorProps}
      ref={forwardedRef}
    />
  )
})

RadioIndicator.displayName = 'RadioIndicator'
export default RadioIndicator
